import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { useParams } from 'react-router-dom'
import Events from './Events'
import EventsProps from './types/EventsProps'
import Filters from './types/Filters'
import Category from './types/Category'

export default ({ ...props }) => {
  const { terms } = useParams()
  const termsArray: Array<string> = terms ? terms.split('&') : []

  // associate terms in URL with their filter groups
  let params: Filters = {
    location: [],
    audience: [],
    type: [],
    language: [],
    series: [],
  }
  const categorySlugs: Filters = {
    location: props.location.map(l => l.slug),
    audience: props.audience.map(a => a.slug),
    type: props.type.map(t => t.slug),
    language: props.language.map(l => l.slug),
    series: props.series.map(s => s.slug),
  }

  termsArray.map(t => {
    Object.keys(categorySlugs).map(c => {
      if (categorySlugs[c].includes(t)) { params[c].push(t) }
    })
  })

  // Filter out past series
  const series = Array.from(new Set(props.events.filter(e => ['week', 'threeMonths'].includes(e.group) && e.series).map(e => e.series.slug))).map(slug => props.series.find(s => s.slug === slug))

  const data: EventsProps = {
    events: props.events,
    location: props.location,
    audience: props.audience,
    type: props.type,
    language: props.language,
    series: series,
    params: params,
  }

  return (<Events {...data} />)
}


